import type { McpOAuthErrorCode } from "@/types/mcp.ts";

export type McpOAuthFailure = {
  code: McpOAuthErrorCode;
  displayName: string;
};

export type McpOAuthDialogContent = {
  title: string;
  description: string;
};

/** Copy shared by web and native so an MCP callback reads the same everywhere. */
export const mcpOAuthDialogContent = ({
  code,
  displayName,
}: McpOAuthFailure): McpOAuthDialogContent | null => {
  const name = displayName.trim() || "MCP server";

  switch (code) {
    case "mcp_cancelled":
      return null;
    case "mcp_admin_action_required":
      return {
        title: `${name} requires administrator action`,
        description: `Ask your organization administrator to enable ${name} API access, then try connecting again.`,
      };
    case "mcp_permissions_changed":
      return {
        title: `${name} permissions changed`,
        description: `We refreshed ${name}’s requested permissions. Close this message and try connecting again.`,
      };
    case "mcp_provider_unavailable":
      return {
        title: `${name} is temporarily unavailable`,
        description: "Try connecting again in a few minutes.",
      };
    case "mcp_authorization_failed":
      return {
        title: `${name} couldn’t authorize the connection`,
        description: `Try again. If it continues, contact your organization administrator or ${name} support.`,
      };
  }
};
